"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
function LostConnectionModal() {
    return ((0, jsx_runtime_1.jsxs)(LostConnectionModalContainer, { children: [(0, jsx_runtime_1.jsx)(SpinnerContainer, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Spinner, { style: {
                        display: 'block',
                        position: 'relative',
                        margin: '15px auto',
                    } }) }), (0, jsx_runtime_1.jsx)(MessageContainer, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Header, Object.assign({ color: "white", size: "medium", style: { margin: 'auto' } }, { children: "You lost your network connection or are currently switching networks. Trying to reconnect." })) })] }));
}
exports.default = LostConnectionModal;
const LostConnectionModalContainer = ui_react_1.styled.div `
    text-align: center;
    position: fixed;
    width: 100vw;
    height: 100vh;
    padding: 30vh 0px;
    z-index: 50;
    background-color: rgba(18, 69, 111, 0.7);
    color: ${props => props.theme.text.color.white};
`;
const SpinnerContainer = ui_react_1.styled.div `
    width: 100vw;
    padding: 16px;
`;
const MessageContainer = ui_react_1.styled.div `
    padding: 40px;
`;
//# sourceMappingURL=lost_connection_modal.js.map